export const INTAKE_BUNDLES = [
  {
    type: "ADULT_FULL_INTAKE_NEW_ASSESSMENT",
    label: "Full Intake - Adult New Assessment",
    ageGroups: ["Adult", "Adolescent"],
    formLabels: [
      "Adult Patient Consent Form",
      "Adult Demographic Info Checklist",
      "Adult History",
      "Adult Hemispheric Checklist",
      "Adult Cognitive Style Assessment",
      "Adult Sensory Function Checklist",
    ],
  },
  {
    type: "CHILD_FULL_INTAKE_NEW_ASSESSMENT",
    label: "Full Intake - Child New Assessment",
    ageGroups: ["Child"],
    formLabels: [
      "Child Patient Consent Form",
      "Child Demographic Info Checklist",
      "Child History",
      "Child Hemispheric Checklist",
    ],
  },
  {
    type: "ADULT_REASSESSMENT",
    label: "Follow Up - Adult Reassessment",
    ageGroups: ["Adult", "Adolescent"],
    formLabels: [
      "Adult Follow Up Form",
      "Patient Consent Form",
      "Adult Hemispheric Checklist",
    ],
  },
  {
    type: "CHILD_REASSESSMENT",
    label: "Follow Up - Child Reassessment",
    ageGroups: ["Child"],
    formLabels: [
      "Child Follow Up Form",
      "Patient Consent Form",
      "Child Hemispheric Checklist",
    ],
  },
  {
    type: "ADULT_NEURODEVELOPMENTAL_NEW_ASSESSMENT",
    label: "Neurodevelopmental Services - Adult New Assessment",
    ageGroups: ["Adult", "Adolescent"],
    formLabels: [
      "Neurodevelopmental Services Consent Form",
      "Adult History",
      "Adult Hemispheric Checklist",
      "Adult Cognitive Style Assessment",
      "Adult Sensory Function Checklist",
    ],
  },
  {
    type: "ADULT_NEURODEVELOPMENTAL_REASSESSMENT",
    label: "Neurodevelopmental Services - Adult Reassessment",
    ageGroups: ["Adult", "Adolescent"],
    formLabels: [
      "Neurodevelopmental Services Consent Form",
      "Adult Hemispheric Checklist",
    ],
  },
  {
    type: "CHILD_NEURODEVELOPMENTAL_NEW_ASSESSMENT",
    label: "Neurodevelopmental Services - Child New Assessment",
    ageGroups: ["Child"],
    formLabels: [
      "Neurodevelopmental Services Consent Form",
      "Child History",
      "Child Hemispheric Checklist",
    ],
  },
  {
    type: "CHILD_NEURODEVELOPMENTAL_REASSESSMENT",
    label: "Neurodevelopmental Services - Child Reassessment",
    ageGroups: ["Child"],
    formLabels: [
      "Neurodevelopmental Services Consent Form",
      "Child Hemispheric Checklist",
    ],
  },
];

export function getIntakeBundlesForAgeGroup(ageGroup) {
  if (!ageGroup) {
    return [];
  }

  const normalizedAgeGroup = String(ageGroup).toLowerCase();

  return INTAKE_BUNDLES.filter((bundle) =>
    bundle.ageGroups.some(
      (allowedAgeGroup) =>
        String(allowedAgeGroup).toLowerCase() === normalizedAgeGroup
    )
  );
}
